import * as React from 'react';
import { Flex } from 'antd';
import {
  Facebook, Instagram, LinkedIn, YouTube,
} from '@mui/icons-material';
import styled from 'styled-components';
import { colors } from '../assets/constStyles';

const FlexStyled = styled(Flex)`
  a svg {
    font-size: 50px;
    transition: color 0.3s ease;
    color: white;

    @media (max-width: 768px) {
      font-size: 30px;
    }
  }

  a:hover svg {
    color: ${colors.colorRed};
  }  
`;

export const FooterSocial: React.FC = () => (
        <FlexStyled gap={10} className={'social_box'} justify={'center'} align={'center'}>
            <a href="https://www.facebook.com/AWMAC.BC" target={'_blank'} rel="noopener noreferrer" aria-label={'Facebook'}>
                <Facebook />
            </a>
            <a href='https://www.linkedin.com/company/awmac-bc/' target={'_blank'} rel="noopener noreferrer" aria-label={'Linkedin'}>
                <LinkedIn />
            </a>
            <a href="https://www.youtube.com/@awmac-britishcolumbiachapt7745" target={'_blank'} rel="noopener noreferrer" aria-label={'Twitter'}>
                <YouTube />
            </a>
            <a href="https://www.instagram.com/awmacbc/" target={'_blank'} rel="noopener noreferrer" aria-label={'Instagram'}>
                <Instagram />
            </a>
        </FlexStyled>
);
